import dispatcher from './dispatcher.fn.js';

export default function(url, params, callback, initiator){

	return fetch( url, params )
		.then((r) => r.json())
		.then((d) => {

			if( Array.isArray(d) ){

				dispatcher( d, initiator, url );

				if(callback)
					callback( d )

			} else{
				console.warn( `Unrecognized response: ${JSON.stringify(d)}` );
			}

		});

}